import React from "react";
import { Tabs } from "antd";
import Agents from "./components/Agents";
import Observability from "./components/Observability";
import Settings from "./components/Settings";
import Audit from "./components/Audit";
import Changelog from "./components/Changelog";

const AiConsole = () => {
  const items = [
    { key: "agents", label: "Agents", children: <Agents /> },
    { key: "observability", label: "Observability", children: <Observability /> },
    { key: "audit", label: "Audit log", children: <Audit /> },
    { key: "settings", label: "Settings", children: <Settings /> },
    { key: "changelog", label: "Changelog", children: <Changelog /> },
  ];

  return (
    <div className="p-2">
      <h1 className="text-xl font-semibold mb-4 text-slate-800 dark:text-white">AI Console</h1>
      <Tabs defaultActiveKey="agents" items={items} />
    </div>
  );
};

export default AiConsole;
